import { TextField, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ProfileLastName = ({ errors, data, register }) => {
  const theme = useTheme();
  const { t } = useTranslation('global');
  return (
    <TextField
      fullWidth
      helperText={errors?.lastName?.message}
      FormHelperTextProps={{
        style: { margin: 0, color: theme.palette.error.main },
        'data-testid': 'helpertext-profile-last-name',
      }}
      inputProps={{
        'data-testid': 'profile-last-name',
        maxLength: 256,
      }}
      label={t('modalProfile.lastName')}
      required={true}
      size="small"
      defaultValue={data?.lastName}
      {...register('lastName', {
        required: t('errors.required'),
        maxLength: {
          value: t('modalProfile.validation.lastName.value'),
          message: t('modalProfile.validation.lastName.message', {
            limit: t('modalProfile.validation.lastName.value'),
          }),
        },
      })}
      error={!!errors.lastName}
    />
  );
};

export default ProfileLastName;
